import { defineComponent, computed, createBlock, openBlock, withCtx, createElementVNode, normalizeClass } from "vue";
import { _ as _sfc_main$1 } from "./p-input-number.js";
import { isNumber } from "lodash-es";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PInputPercent"
  },
  __name: "p-input-percent",
  props: {
    modelValue: {
      type: [Number, String],
      default: null
    },
    size: {
      type: String,
      default: "md"
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const prefixClasses = {
      sm: "text-sm h-8 left-2",
      md: "text-base h-10 left-3",
      lg: "text-lg h-12 left-5"
    };
    const props = __props;
    const emit = __emit;
    const convertedValue = computed({
      get: () => isNumber(props.modelValue) ? props.modelValue * 100 : props.modelValue,
      set: (nV) => emit("update:modelValue", isNumber(nV) ? nV / 100 : nV)
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(_sfc_main$1, {
        modelValue: convertedValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => convertedValue.value = $event),
        size: __props.size
      }, {
        prefix: withCtx(() => [
          createElementVNode("div", {
            class: normalizeClass(["absolute flex items-center", prefixClasses[__props.size]])
          }, _cache[1] || (_cache[1] = [
            createElementVNode("div", null, "%", -1)
          ]), 2)
        ]),
        _: 1
      }, 8, ["modelValue", "size"]);
    };
  }
});
export {
  _sfc_main as _
};
